export default __webpack_public_path__ + "static/julius-geis-8cd0e68c6304e9aa30ef058b844dedbb.png";